
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Features from './Features';
import StayInformed from './StayInformed';
import LeverageRealtimeData from './LeverageRealtimeData';
import TViewTicker from './TViewTicker'
import Hero from './Hero';
function Home() {
    return (
        <>
            <Header />
            <Hero/>
            <LeverageRealtimeData/>
            <StayInformed/>
            <Features/>   
            <Footer />
        </>
    );
}

export default Home;
